"use strict";

import Browser from './util/browser'
import BtnHamburger from './btn/btnhumberger';
import Gnav from './section/gnav';
import BtnPageTop from './btn/btnpagetop';
import BtnTab from './btn/btntab';

window.onload = function(){
	new Spot();
}

class Spot{
	constructor(){
		//Gnav
		this.gnav = new Gnav( $('#Gnav') );
		
		//BtnHamburger
		this.btnHamburger = new BtnHamburger( $('#BtnHamburger') );
		
		//PageTop
		this.btnPageTop = new BtnPageTop( $('#BtnPageTop') );
		
		this.btnSanpoBottom = new BtnTab( $('#BtnSanpoBottom') );
		
		
		$('#Header .menu a').on('click',(e)=>{
			let $target = $(e.currentTarget);
			let hash = $target.attr('href');
			$(hash).velocity('scroll', { duration: 500, easing: "easeInOutQuad" , delay:0 });
			return false;
		})
		
		this.initEvent();
	}
	
	initEvent(){
/*
		let tabChangeFunc = (e)=>{
			if( e.$con.attr('id') == 'BtnSanpoBottom' || e.$con.attr('id') == 'BtnZoomBottom' ){
				this.tabChange(e.$con.data('id'),false,600);
			} else {
				this.tabChange(e.$con.data('id'),false,300);
			}
		};
		this.btnSanpo.on('click' , tabChangeFunc);
		this.btnZoom.on('click' , tabChangeFunc);
		this.btnZoomBottom.on('click' , tabChangeFunc);
		this.btnSanpoBottom.on('click' , tabChangeFunc);
		$('#BtnSanpoFooter').on('click' , ()=>{ this.tabChange( 'TabSanpo',true,500); });
		$('#BtnZoomFooter').on('click' , ()=>{ this.tabChange( 'TabZoom',true,500); });
*/
		
		let navToggleFunc = ()=>{
			if(this.gnav.isOpen){
				this.gnav.close();
				this.btnHamburger.close();
			} else {
				this.gnav.open();				
				this.btnHamburger.open();
			}
		};
		this.btnHamburger.on('click' , navToggleFunc);
		this.gnav.on('nav_click' , (id)=>{
			//navToggleFunc();
			//this.tabChange(id,false,1);
		});
	}
}


// WEBPACK FOOTER //
// ./js/spot.js